// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

// Dish Tech React
import {useRouter} from '@dishtech-react/hooks';
import {AuthLoading, Unauthorized} from '@dishtech-react/core';

// Components
import MainNav from './main-nav';

// Contexts
import {RouteContext} from '../../../contexts/route-context';

// Images
import logo from '../../../images/ripple-name-logo.svg';

const Main = ({children}) => {
    const authorized = useSelector(({auth: {user: {isAuthorized} = {}} = {}}) => isAuthorized);
    const isCredentialExpired = useSelector(
        ({auth: {user: {credentialsNonExpired} = {}} = {}}) => !credentialsNonExpired
    );

    return (
        <div className="main">
            <RouteContext.Provider value={useRouter()}>
                {isCredentialExpired ? (
                    <AuthLoading img={logo} />
                ) : authorized !== false ? (
                    <MainNav>
                        <div className="main--content">{children}</div>
                    </MainNav>
                ) : (
                    <Unauthorized />
                )}
            </RouteContext.Provider>
        </div>
    );
};

Main.propTypes = {
    children: PropTypes.node,
};

export default Main;
